export const environment = {
  apiUrl: 'https://x4tarif-api-staging.azurewebsites.net',
  storageUrl: 'https://x4tarifstorage.blob.core.windows.net/staging',
  production: false
};
